import React from 'react'

import storeLocatorSearchForm from '@fixtures/store-locator-search-form.json'

import {
  getHeaderData,
  getFooterData,
  getStoreLocatorData,
  getStoreLocatorPageData,
} from '@api/index'

import Breadcrumb from '@/molecules/Breadcrumb'
import { SectionBuilder } from '@/organisms'
import StoreLocatorForm from '@/organisms/StoreLocatorForm'

import Layout from '@/organisms/Layout'

import { default as normalizeHeaderData } from '@models/Header'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import { default as normalizeStoreLocatorData } from '@models/StoreLocator'
import normalizeMetadata from '@models/Metadata'

export const getServerSideProps = async () => {
  const [footer, header, storeLocatorData, storeLocatorPageData] =
    await Promise.all([
      getFooterData(),
      getHeaderData(),
      getStoreLocatorData(),
      getStoreLocatorPageData(),
    ])
  const { banks, banksSelect, productsSelect } = normalizeStoreLocatorData(
    storeLocatorData || { body: [] }
  )

  return {
    props: {
      metadata: normalizeMetadata(storeLocatorPageData.seo),
      content: {
        sections: storeLocatorPageData.sections,
        form: storeLocatorSearchForm,
      },
      breadcrumb: normalizeBreadcrumb([{ label: 'Filiale più vicina' }]),
      header: normalizeHeaderData(header),
      footer: normalizeFooterData(footer),
      storeLocatorData: {
        banks,
        form: {
          method: 'GET',
          endpoint: 'api/arca/banche/filiali',
          baseUrlEndpoint: 'proxy',
          fieldGroups: [
            {
              title: 'Dove ti trovi?',
              fields: [
                {
                  type: 'search',
                  id: 'modalStoreLocatorSearch',
                  name: 'storeLocatorSearch',
                  placeholder: 'Inserisci qui il tuo indirizzo',
                  required: true,
                  'aria-required': 'true',
                  autocomplete: 'search',
                  geolocate: true,
                  googleAutocomplete: true,
                  button: {
                    type: 'submit',
                    iconEnd: 'search',
                    ariaLabel: 'Cerca banca',
                  },
                  col: {
                    xs: 12,
                    md: 12,
                  },
                  validationType: 'string',
                  validations: [
                    {
                      type: 'required',
                      params: ['Inserisci un indirizzo'],
                    },
                  ],
                },
              ],
            },
            {
              title: 'Filtra per:',
              inline: true,
              fields: [
                {
                  type: 'select',
                  id: 'abiBanca',
                  name: 'abiBanca',
                  placeholder: 'Banca di riferimento',
                  isMulti: false,
                  isSearchable: false,
                  isClearable: true,
                  closeMenuOnSelect: true,
                  options: banksSelect,
                  col: {
                    xs: 12,
                    md: 4,
                  },
                },
                {
                  type: 'select',
                  id: 'codiceProdottoVendita',
                  name: 'codiceProdottoVendita',
                  placeholder: 'Nome prodotto',
                  isMulti: false,
                  isSearchable: true,
                  isClearable: true,
                  closeMenuOnSelect: true,
                  options: productsSelect,
                  col: {
                    xs: 12,
                    md: 4,
                  },
                },
              ],
            },
          ],
          initialValues: {
            storeLocatorSearch: '',
            lat: '',
            lng: '',
            limit: 10,
            offset: 0,
            abiBanca: '',
            codiceProdottoVendita: '',
          },
          debug: false,
          reCaptcha: false,
        },
      },
    },
  }
}

export default function StoreLocatorPage({
  content,
  metadata,
  breadcrumb,
  header,
  footer,
  storeLocatorData,
}) {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
    >
      <Breadcrumb items={breadcrumb} />
      {content.sections.length > 0 ? (
        <SectionBuilder data={content.sections} />
      ) : null}
      <StoreLocatorForm
        data={storeLocatorData}
        formData={content.form}
      />
    </Layout>
  )
}
